import React from "react";
import "./Contacts.css";
import { ReactComponent as Mail } from '../../icons/contacts/email.svg';
import { ReactComponent as Telegram } from '../../icons/contacts/tg.svg';
import { ReactComponent as Whatsapp } from '../../icons/contacts/wa.svg';
import { ReactComponent as Phone } from '../../icons/contacts/phone.svg';
import {useTranslation} from "react-i18next";
import {Link, useNavigate} from "react-router-dom";
import {useAuth} from "../../AuthContext";

export const Contacts = ({ onLinkClick, showContactIcons = true }) => {
    const { user, logout, loading } = useAuth();
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="contacts">
            {showContactIcons && <div className={'contactsIcons'}>
                <a href="https://t.me/smsretail" target="_blank" rel="noreferrer" className='contactline'><Telegram /></a>
                <a href="https://api.whatsapp.com/send?phone=79500463666" target="_blank" rel="noreferrer" className='contactline'><Whatsapp /></a>
                <a href="tel:+37496225758" className='contactlinephone'><Phone /></a>
                <a href="mailto:info@sms-retail.ru" target="_blank" rel="noreferrer" className='contactline'><Mail /></a>
            </div>}
            {loading ? (
                        <div className="userInfoH">
                            <div className="spinnerH" />
                            Загрузка...
                        </div>
                    ) :
                user ? (
                <div className="userInfoH">
                    <Link className="userInfoAcc" onClick={onLinkClick} to="/portal">{t('account')}</Link> <button className="userInfoLogout" onClick={() => {logout();onLinkClick();}}>{t('logout')}</button>
                </div>
            ) : (
            <button
                onClick={() => {
                    onLinkClick();
                    navigate('/login')
                }}
                className="authButton"
            >
                <div className="authButtonText">{t('getStartedButton')}</div>
            </button>
                )}
        </div>
    );
};
